class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.containerElement = 'cart-items';

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.dispatchEvent(new Event('cartRemove'));
      this.closest(this.containerElement).updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawerCartRemoveButton extends CartRemoveButton {
  constructor() {
    super();
    this.containerElement = 'cart-drawer-cart-items';
  }
}

customElements.define('cart-drawer-cart-remove-button', CartDrawerCartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();

    this.containerElementId = 'main-cart-items';
    this.cartStatusElementId = 'cart-live-region-text';
    this.cartStatusSectionId = 'cart-live-region-text';
    this.cartErrorsElementId = 'cart-errors';
    this.footerElementId = 'main-cart-footer';
    this.cartItemPrefix = '#CartItem-';
    this.cartItemErrorPrefix = 'Line-item-error-';
    this.quantityPrefix = 'Quantity-';
    this.lineItemStatusElementId = 'shopping-cart-line-item-status';

    this.lineItemStatusElement = document.getElementById(this.lineItemStatusElementId);

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

    document.body.addEventListener('product-form-submitted', this.onProductFormSubmitted.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onProductFormSubmitted(event) {

    this.currentItemCount += parseInt(event.quantity);
  }

  getSectionsToRender() {
    return [
      {
        id: this.containerElementId,
        section: document.getElementById(this.containerElementId).dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: this.cartStatusElementId,
        section: this.cartStatusElementId,
        selector: '.shopify-section'
      },
      {
        id: this.footerElementId,
        section: document.getElementById(this.footerElementId).dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-value-banners',
        section: document.getElementById(this.footerElementId).dataset.id,
        selector: '.cart-value-banners-js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById(this.footerElementId);

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`${this.cartItemPrefix + line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new Event('cartChange'));
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById(this.cartErrorsElementId).textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`${this.cartItemErrorPrefix + line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`${this.quantityPrefix + line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById(this.cartStatusElementId);
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById(this.containerElementId).classList.add('cart__items--disabled');

    this.querySelectorAll(`${this.cartItemPrefix + line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById(this.containerElementId).classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

class CartDrawerCartItems extends CartItems {
  constructor() {
    super();

    this.containerElementId = 'cart-drawer-cart-items';
    this.cartStatusElementId = 'cart-drawer-live-region-text';
    this.cartStatusSectionId = 'cart-live-region-text';
    this.cartErrorsElementId = 'cart-drawer-errors';
    this.footerElementId = 'cart-drawer-footer';
    this.cartItemPrefix = '#CartDrawerCartItem-';
    this.cartItemErrorPrefix = 'Cart-drawer-line-item-error-';
    this.quantityPrefix = 'Cart-drawer-quantity-';
    this.lineItemStatusElementId = 'cart-drawer-line-item-status';

    this.lineItemStatusElement = document.getElementById(this.lineItemStatusElementId);
  }

  getSectionsToRender() {
    return [
      {
        id: this.containerElementId,
        section: this.containerElementId,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: this.cartStatusElementId,
        section: this.cartStatusSectionId,
        selector: '.shopify-section'
      },
      {
        id: this.footerElementId,
        section: this.footerElementId,
        selector: '.js-contents'
      }
    ];
  }

  async forceRefresh() {
    const sectionsToRender = this.getSectionsToRender();

    const sectionHandles = sectionsToRender.map(function (entry) {
      return entry.section;
    });

    const sectionsParam = encodeURIComponent(sectionHandles.join(","));

    const basePath = window.location.pathname;

    const requestUrl =
      `${window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/"}?sections=${sectionsParam}&sections_url=${encodeURIComponent(basePath)}`;

    const response = await fetch(requestUrl, { headers: { "Accept": "application/json" } });

    if (!response.ok) {
      return;
    }

    const sectionsJson = await response.json();

    sectionsToRender.forEach(function (entry) {
      const targetContainer = document.getElementById(entry.id);

      if (!targetContainer) {
        return;
      }

      const elementToReplace = targetContainer.querySelector(entry.selector) || targetContainer;

      const htmlString = sectionsJson[entry.section];

      if (typeof htmlString !== "string") {
        return;
      }

      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(htmlString, "text/html");
      const newInner = parsedDoc.querySelector(entry.selector);

      if (!newInner) {
        return;
      }

      elementToReplace.innerHTML = newInner.innerHTML;
    });

    document.dispatchEvent(new Event("cartChange"));
  }
}

customElements.define('cart-drawer-cart-items', CartDrawerCartItems);

document.addEventListener("DOMContentLoaded", function () {
  const errorElements = document.querySelectorAll(".product-form__error-message");

  if (!errorElements.length) {
    return;
  }

  const observer = new MutationObserver(function () {
    const drawer = document.querySelector("cart-drawer-cart-items");

    if (!drawer || typeof drawer.forceRefresh !== "function") {
      return;
    }

    drawer.forceRefresh();
  });

  errorElements.forEach(function (el) {
    observer.observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });
});
